// src/store/reducers/cardReducer.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { base_url } from '../../utils/config'

// Thunks
export const add_to_card = createAsyncThunk(
  'card/add_to_card',
  async (info, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.post(
        `${base_url}/api/home/product/add-to-card`,
        info,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      console.log(error.response)
      return rejectWithValue(error.response.data)
    }
  }
)

export const get_card_products = createAsyncThunk(
  'card/get_card_products',
  async (userId, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.get(
        `${base_url}/api/home/product/get-card-product/${userId}`,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const delete_card_product = createAsyncThunk(
  'card/delete_card_product',
  async (card_id, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.delete(
        `${base_url}/api/home/product/delete-card-product/${card_id}`,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const quantity_inc = createAsyncThunk(
  'card/quantity_inc',
  async (card_id, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.put(
        `${base_url}/api/home/product/quantity-inc/${card_id}`,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const quantity_dec = createAsyncThunk(
  'card/quantity_dec',
  async (card_id, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.put(
        `${base_url}/api/home/product/quantity-dec/${card_id}`,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const add_to_wishlist = createAsyncThunk(
  'wishlist/add_to_wishlist',
  async (info, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.post(
        `${base_url}/api/home/product/add-to-wishlist`,
        info,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const get_wishlist_products = createAsyncThunk(
  'wishlist/get_wishlist_products',
  async (userId, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.get(
        `${base_url}/api/home/product/get-wishlist-products/${userId}`,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const remove_wishlist = createAsyncThunk(
  'wishlist/remove_wishlist',
  async (wishlistId, { rejectWithValue, fulfillWithValue, getState }) => {
    const { token } = getState().auth
    const config = { headers: { Authorization: `Bearer ${token}` } }
    try {
      const { data } = await axios.delete(
        `${base_url}/api/home/product/delete-wishlist-product/${wishlistId}`,
        config
      )
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// Slice
export const cardReducer = createSlice({
  name: 'card',
  initialState: {
    card_products: [],
    card_product_count: 0,
    buy_product_item: 0,
    wishlist_count: 0,
    wishlist: [],
    price: 0,
    errorMessage: '',
    successMessage: '',
    shipping_fee: 0,
    outofstock_products: []
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
    reset_count: (state) => {
      state.card_product_count = 0
      state.wishlist_count = 0
    }
  },
  extraReducers: {
    // ADD TO CART
    [add_to_card.rejected]: (state, { payload }) => {
      state.errorMessage = payload.error
    },
    [add_to_card.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message
      state.card_product_count += 1

      // if API returns updated list & totals:
      if (payload.card_products) {
        state.card_products       = payload.card_products
        state.price               = payload.price
        state.shipping_fee        = payload.shipping_fee
        state.buy_product_item    = payload.buy_product_item
        state.outofstock_products = payload.outOfStockProduct
      }
    },

    // GET CART PRODUCTS
    [get_card_products.fulfilled]: (state, { payload }) => {
      state.card_products       = payload.card_products
      state.price               = payload.price
      state.card_product_count  = payload.card_product_count
      state.shipping_fee        = payload.shipping_fee
      state.outofstock_products = payload.outOfStockProduct
      state.buy_product_item    = payload.buy_product_item
    },

    // DELETE CART PRODUCT
    [delete_card_product.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message

      // if API returns updated list:
      if (payload.card_products) {
        state.card_products      = payload.card_products
        state.card_product_count = payload.card_product_count
      }
    },

    // INCREASE QUANTITY
    [quantity_inc.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message

      // if API returns updated list:
      if (payload.card_products) {
        state.card_products      = payload.card_products
        state.price              = payload.price
        state.buy_product_item   = payload.buy_product_item
        state.shipping_fee       = payload.shipping_fee
        state.outofstock_products = payload.outOfStockProduct
        state.card_product_count = payload.card_product_count
      }
    },

    // DECREASE QUANTITY
    [quantity_dec.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message

      // if API returns updated list:
      if (payload.card_products) {
        state.card_products      = payload.card_products
        state.price              = payload.price
        state.buy_product_item   = payload.buy_product_item
        state.shipping_fee       = payload.shipping_fee
        state.outofstock_products = payload.outOfStockProduct
        state.card_product_count = payload.card_product_count
      }
    },

    // WISHLIST THUNKS (UNCHANGED)
    [add_to_wishlist.rejected]: (state, { payload }) => {
      state.errorMessage = payload.error
    },
    [add_to_wishlist.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message
      state.wishlist_count = state.wishlist_count > 0 ? state.wishlist_count + 1 : 1
    },
    [get_wishlist_products.fulfilled]: (state, { payload }) => {
      state.wishlist       = payload.wishlists
      state.wishlist_count = payload.wishlistCount
    },
    [remove_wishlist.fulfilled]: (state, { payload }) => {
      state.successMessage  = payload.message
      state.wishlist        = state.wishlist.filter(p => p._id !== payload.wishlistId)
      state.wishlist_count -= 1
    }
  }
})

export const { messageClear, reset_count } = cardReducer.actions
export default cardReducer.reducer
